import AutoframedVideoAsset from './AutoframedVideoAsset';

export default AutoframedVideoAsset;
